import React, { ReactElement } from "react";
import oc from "open-color";
import { IoMdSpeedometer } from "react-icons/io";
import { MemoizedValue } from "../../../helpers/memoizer";
import { STALE_COLOR } from ".";

export default function Counter({
  name,
  value,
}: {
  name: string;
  value?: MemoizedValue;
}): ReactElement {
  const color = !value?.displayValue || value?.isStale ? STALE_COLOR : oc.gray[9];
  return (
    <div
      style={{
        borderRadius: "5px",
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <div>
        <IoMdSpeedometer size={24} style={{ marginRight: "8px" }} />
        <div style={{ display: "inline-block" }}>{name}</div>
      </div>
      <div className="d-flex">
        <div
          className="d-flex flex-column align-items-end mr-3 rounded"
          style={{ fontWeight: "bold", fontFamily: "monospace" }}
        >
          <div style={{ color }}>{value?.displayValue || "-"}</div>
        </div>
        <div className="d-flex flex-column align-items-start">
          <div>m³</div>
        </div>
      </div>
    </div>
  );
}
